module.exports = __webpack_public_path__ + "static/media/404.6695af99.svg";